import {gql} from '@apollo/client'

export const BASE_GROUP_FIELDS = gql`
  fragment BaseGroupFields on Group {
    id
    name
    colour
    numOfDraftAccounts
    numOfActiveAccounts
    numOfArchivedAccounts
  }
`

export const CREATE_GROUP = gql`
  ${BASE_GROUP_FIELDS}
  mutation CreateGroup($name: String, $colour: String) {
    group(name: $name, colour: $colour) {
      ...BaseGroupFields
    }
  }
`

export const UPDATE_GROUP = gql`
  ${BASE_GROUP_FIELDS}
  mutation UpdateGroup($id: ID, $name: String, $colour: String) {
    group(id: $id, name: $name, colour: $colour) {
      ...BaseGroupFields
    }
  }
`
